<template>
    <div class="fill flex column flex-fill">
        <div class="opt r">
            <!-- <input-date
            inputClass="secondary"
            v-show="tab == 'Documentos Recibidos'"
            class="ml5"
            v-model="searchDtesReceived"
            :icon="mobile ? 'calendar' : ''"
            type="DATE"
            format="timestamp"
            @OnAcceptDate="LoadDtesReceived(true)">
            </input-date> -->

            <input-field v-if="tab == 'Documentos Recibidos'" slot="options"
            inputClass="secondary"
            v-model="searchDtesReceived"
            @OnChange="LoadDtesReceived(true)"
            placeholder="Buscar..."
            pre="search"
            :icon="mobile ? 'search' : ''"
            cleareable
            :timeout="1000"
            >
            </input-field>

            <input-field v-if="tab == 'Facturas Electrónicas'" slot="options"
            inputClass="secondary"
            v-model="searchIssuerFE"
            @OnChange="LoadDtes(true)"
            placeholder="Buscar..."
            pre="search"
            :icon="mobile ? 'search' : ''"
            cleareable
            :timeout="1000"
            >
            </input-field>

            <input-range inputClass="secondary"
            v-show="tab == 'Documentos Recibidos'"
            class="ml5"
            v-model="rangeDtesReceived"
            :icon="mobile ? 'calendar' : ''"
            @OnValueChanged="tab == 'Documentos Recibidos' ? LoadDtesReceived() : null"
            ref="rangeDate"
            > </input-range>
            
            <input-date
            inputClass="secondary"
            v-show="tab == 'Facturas Electrónicas'"
            class="ml5"
            v-model="searchFE"
            :icon="mobile ? 'calendar' : ''"
            type="DATE"
            format="timestamp"
            @OnAcceptDate="LoadDtes(true)">
            </input-date>

            <input-date
            inputClass="secondary"
            v-show="tab == 'Notas de Crédito'"
            class="ml5"
            v-model="searchNC"
            :icon="mobile ? 'calendar' : ''"
            type="DATE"
            format="timestamp"
            @OnAcceptDate="LoadNotasDeCredito(true)">
            </input-date>

            <input-date
            inputClass="secondary"
            v-show="tab == 'Notas de Débito'"
            class="ml5"
            v-model="searchND"
            :icon="mobile ? 'calendar' : ''"
            type="DATE"
            format="timestamp"
            @OnAcceptDate="LoadNotasDeDebito(true)">
            </input-date>

            <input-date
            inputClass="secondary"
            v-show="tab == 'Guías de Despacho'"
            class="ml5"
            v-model="searchGD"
            :icon="mobile ? 'calendar' : ''"
            type="DATE"
            format="timestamp"
            @OnAcceptDate="LoadDispatchGuides(true)">
            </input-date>
            
            <input-select v-if="tab == 'Documentos Recibidos'"
            class="ml5" inputClass="secondary" icon="filter"
            v-model="sortDtesReceived"
            slot="options"
            :items="[
                {text: 'Mostrar Todos', value: null},
                {text: 'Facturas Electrónicas', value: 33},
                {text: 'Notas de Crédito Electrónica', value: 61},
                {text: 'Notas de Débito Electrónica', value: 56},
            ]">
            </input-select>

            <input-field v-if="tab == 'Receptores'" slot="options"
            inputClass="secondary"
            v-model="searchReceiver"
            placeholder="Buscar..."
            pre="search"
            cleareable
            :timeout="300"
            @OnChange="GetReceivers(true, true)">
            </input-field>

            <input-select v-if="tab == 'Facturas Electrónicas'"
            class="ml5" inputClass="secondary" icon="sort"
            v-model="sortFacturas"
            slot="options"
            :items="[
                {text: 'Ordenar por número', value: 'folio,desc'},
                {text: 'Ordenar por emisión', value: 'issue_at,desc'},
            ]">
            </input-select>
            
            <i class="options icon-dots-vertical ml5" @click="Options([
                { text: 'Buscar Factura', function: () => {modalFacturaSearch={number: 0}}, icon: 'search'},
                { text: 'Emitir Factura', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.Open(33) }, icon: 'square-plus' },
            ])" v-show="tab == 'Facturas Electrónicas'"></i>

            <i class="options icon-dots-vertical ml5" @click="Options([
                { text: 'Emitir Nota de Crédito', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.Open(61) }, icon: 'square-plus' },
            ])" v-show="tab == 'Notas de Crédito'"></i>

            <i class="options icon-dots-vertical ml5" @click="Options([
                { text: 'Emitir Nota de Débito', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.Open(56) }, icon: 'square-plus' },
            ])" v-show="tab == 'Notas de Débito'"></i>

            <i class="options icon-dots-vertical ml5" @click="Options([
                { text: 'Emitir Guía de Despacho Electrónica', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.Open(52) }, icon: 'square-plus' },
            ])" v-show="tab == 'Guías de Despacho'"></i>

            <i class="options icon-dots-vertical ml5" @click="Options([
                { text: 'Crear Receptor', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.OpenModalReceiver() }, icon: 'plus' },
            ])" v-show="tab == 'Receptores'"></i>
        </div>

        <tabs v-model="tab" v-if="tabs" :tabs="tabs" :keyByTab="true" :tabCount="tabCount" 
        @OnTabReceptores="GetReceivers(true)" 
        @OnTabNotasdeCredito="LoadNotasDeCredito(true)"
        @OnTabNotasdeDebito="LoadNotasDeDebito(true)"
        @OnTabFacturasElectronicas="LoadDtes(true)"
        @OnTabGuiasdeDespacho="LoadDispatchGuides(true)"
        tabCountOnSelectedOnly>
            <vertical-content class="pa-body" slot="Documentos Recibidos" ref="verticalContentReceived" @OnBottom="LoadDtesReceived()" :list="dtesReceived">
                <div class="secondary-text ta-center mt10" v-if="!dtesReceived || !dtesReceived.length">No hay registros de documentos recibidos.</div>
                <div v-else>
                    <div class="section mb10 selectable" v-for="(dte, index) in showProviders" :key="index"
                        @click="$refs.invoiceSii.OpenModalFacturaDetail(dte, index)">
                        <div class="flex fill align-center">
                            <avatar class="mr10"
                            :defaultImageIcon="dte.type >= 55 && dte.type <= 61 ? 130 : 111">
                            </avatar>
                            <div class="flex column flex-fill">
                                <div class="bold"><span class="bold">{{ DTELabel[dte.type] ? DTELabel[dte.type].text : Util.DTE[dte.type] }} N°</span>{{ Util.Number(dte.folio) }}</div>
                                <div class="bold" v-if="dte.issuer_name">{{ dte.issuer_name }}</div>
                                <div class="secondary-text" v-if="dte.issue_at">
                                    <span class="bold">Fecha de emisión: </span>{{ Util.Date(dte.issue_at, 'DD/MM/YYYY') }}
                                    <br>
                                    <span :class="`bold ${AppliedSummary(dte).color}`" v-if="dte.type == 33"> {{  AppliedSummary(dte).msg }} </span>
                                </div>
                            </div>
                            <div class="bold" v-if="dte.total">{{ Util.Price(dte.total) }}</div>
                            <div class="options icon-dots-vertical ml10" @click.stop="Options([
                                { text: 'Imprimir', function: () => $refs.invoiceSii.PrintFactura(dte), icon: 'printing'},
                                { text: 'Descargar PDF', function: () => { $refs.invoiceSii.GetDtePDF(33, dte.id, dte.folio, false, true) }, icon: 'download' },
                                { text: 'Enviar '+Util.DTE[dte.type], class: 'selected-color', function: () => { $refs.modalFacturaElectronica.OpenmodalSendDte({...dte, recieved: true}) }, icon: 'mail' },
                            ])"></div>
                        </div>
                    </div>
                </div>
            </vertical-content>
            <vertical-content class="pa-body" slot="Facturas Electrónicas" ref="verticalContentFacturas" @OnBottom="BottomFacturas()" :list="facturas">
                <div class="secondary-text ta-center mt10" v-if="!facturas || !facturas.length">No hay registros de facturas electrónicas.</div>
                <div v-else>
                    <div class="section mb10 selectable" v-for="(factura, index) in facturas" :key="index"
                        @click="$refs.invoiceSii.modalFacturaDetail = factura">
                        <div class="flex fill align-center">
                            <avatar class="mr10"
                            defaultImageIcon="111"
                            :color="AvatarColor(Util.FacturaStatus[factura.status].color)">
                            </avatar>
                            <div class="flex column flex-fill">
                                <div class="bold"><span class="bold">Factura N°</span>{{ factura.folio }}</div>
                                <div class="bold" v-if="factura.recipient_name">{{ factura.recipient_name }}</div>
                                <div class="secondary-text" v-if="factura.issue_at">
                                    <span class="bold">Fecha de emisión: </span>{{ Util.Date(factura.issue_at, 'DD/MM/YYYY') }}
                                </div>
                                <div class="secondary-text">
                                    <span :class="`bold ${Util.FacturaStatus[factura.resend_status? factura.resend_status : factura.status].color}`">Estado: </span>
                                    <span :class="`${factura.resend_status? 'line-through' : ''} ${Util.FacturaStatus[factura.status].color}`">{{ Util.FacturaStatus[factura.status].label }}</span>
                                    <span v-if="factura.resend_status" class="ml5"> 
                                        <i class="icon icon-arrow-right mr5"></i>
                                        <span :class="`${Util.FacturaStatus[factura.resend_status].color}`">
                                            {{ Util.FacturaStatus[factura.resend_status].label }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="bold" v-if="factura.total">
                                {{ Util.Price(factura.total) }}</div>
                            <div class="options icon-dots-vertical ml10" @click.stop="Options([
                                { text: 'Obtener estado avanzado', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin', function: () => { GetAdvancedStatus(factura.id, factura.type) } },
                                { text: 'Obtener estado vía mail', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && factura.xml_status_mail != null, function: () => { modalStatusXml = factura.xml_status_mail } },
                                { text: 'Forzar estado OK', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin', confirm: '¿Se verificó que la factura electrónica esté aprobado y recepcionado en el SII?', function: () => { ForceOkStatus(factura) } },
                                { text: 'Obtener registro', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin', function: () => { GetSqlDte(factura.id, factura.type) } },
                                { text: 'Cancelar factura electrónica', class: 'error-color', if: factura.status == 'OK', function: () => { CancelFactura(factura.id) }, icon: 'forbidden' },
                                { text: 'Reenviar factura electrónica', if: factura.status == 'ERROR' || factura.status == 'FAILED', confirm: '¿Desea reenviar la factura electrónica? Esta acción consumirá folios', function: () => { ResendFactura(factura) }, icon: 'right-arrow' },
                                { text: 'Imprimir', function: () => $refs.invoiceSii.PrintFactura(factura), icon: 'printing'},
                                { text: 'Descargar PDF Tributario', function: () => { $refs.invoiceSii.GetDtePDF(33, factura.id, factura.folio) }, icon: 'download' },
                                { text: 'Descargar PDF Cedible', function: () => { $refs.invoiceSii.GetDtePDF(33, factura.id, factura.folio, true) }, icon: 'download' },
                                { text: factura.id_cesion ? 'Reenviar cesión' : 'Ceder factura electrónica', if: factura.type == 33 && factura.status == 'OK', function: () => { factura.id_cesion ? $refs.modalFacturaElectronica.OpenModalReenviarCesion(factura) : $refs.modalFacturaElectronica.OpenModalCesion(factura) }, icon: factura.id_cesion ? 'mail' : 'right-arrow' },
                                { text: 'Enviar factura electrónica', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.OpenmodalSendDte(factura) }, icon: 'mail' },
                            ])"></div>
                        </div>
                    </div>
                </div>
            </vertical-content>
            <vertical-content class="pa-body" slot="Notas de Crédito" ref="verticalContentNotasCredito" @OnBottom="BottomNotasCredito()" :list="notasCredito">
                <div class="secondary-text ta-center mt10" v-if="!notasCredito || !notasCredito.length">No hay registros de notas de crédito.</div>
                <div v-else>
                    <div class="section mb10 selectable" v-for="(notaCredito, index) in notasCredito" :key="index" @click="$refs.invoiceSii.modalFacturaDetail = notaCredito">
                        <div class="flex fill align-center">
                            <avatar class="mr10"
                            defaultImageIcon="130"
                            :color="AvatarColor(Util.FacturaStatus[notaCredito.status].color)">
                            </avatar>
                            <div class="flex column flex-fill">
                                <div class="bold"><span class="bold">Nota de Crédito N°</span>{{ notaCredito.folio }}</div>
                                <div class="secondary-text" v-if="notaCredito.send_at">
                                    <span class="bold">Fecha de emisión: </span>{{ Util.Date(notaCredito.send_at, 'DD/MM/YYYY') }}
                                </div>
                                <div :class="`secondary-text ${Util.FacturaStatus[notaCredito.status].color}`"><span class="bold">Estado:
                                    </span>{{ Util.FacturaStatus[notaCredito.status].label }}</div>
                            </div>
                            <div class="bold" v-if="notaCredito.total && notaCredito.total">
                                {{ Util.Price(notaCredito.total) }}</div>
                            <div class="options icon-dots-vertical ml10" @click.stop="Options([
                                // { text: 'Cancelar nota de crédito electrónica', class: 'error-color', if: notaCredito.status == 'OK', function: () => { cancelNC(notaCredito.id) } },
                                { text: 'Forzar estado OK', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin', confirm: '¿Se verificó que la nota de crédito esté aprobada y recepcionada en el SII?', function: () => { ForceOkStatus(notaCredito) } },
                                { text: 'Obtener estado avanzado', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && notaCredito.status != 'OK', function: () => { GetAdvancedStatus(notaCredito.id, notaCredito.type) } },
                                { text: 'Obtener estado vía mail', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && notaCredito.xml_status_mail != null, function: () => { modalStatusXml = notaCredito.xml_status_mail } },
                                { text: 'Obtener registro', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && notaCredito.status != 'OK', function: () => { GetSqlDte(notaCredito.id, notaCredito.type) } },
                                { text: 'Descargar PDF', function: () => { $refs.invoiceSii.GetDtePDF(61, notaCredito.id, notaCredito.folio) }, icon: 'download' },
                                { text: 'Enviar Nota de Crédito Electrónica', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.OpenmodalSendDte(notaCredito, notaCredito.type) }, icon: 'mail' },
                            ])"></div>
                        </div>
                    </div>
                </div>
            </vertical-content>
            <vertical-content class="pa-body" slot="Notas de Débito" ref="verticalContentNotasDebito" @OnBottom="BottomNotasDebito()" :list="notasDebito">
                <div class="secondary-text ta-center mt10" v-if="!notasDebito || !notasDebito.length">No hay registros de notas de débito.</div>
                <div v-else>
                    <div class="section mb10 selectable" v-for="(notaDebito, index) in notasDebito" :key="index" @click="$refs.invoiceSii.modalFacturaDetail = notaDebito">
                        <div class="flex fill align-center">
                            <avatar class="mr10"
                            defaultImageIcon="130"
                            :color="AvatarColor(Util.FacturaStatus[notaDebito.status].color)">
                            </avatar>
                            <div class="flex column flex-fill">
                                <div class="bold"><span class="bold">Nota de Débito N°</span>{{ notaDebito.folio }}</div>
                                <div class="secondary-text" v-if="notaDebito.send_at">
                                    <span class="bold">Fecha de emisión: </span>{{ Util.Date(notaDebito.send_at, 'DD/MM/YYYY') }}
                                </div>
                                <div :class="`secondary-text ${Util.FacturaStatus[notaDebito.status].color}`"><span class="bold">Estado:
                                    </span>{{ Util.FacturaStatus[notaDebito.status].label }}</div>
                            </div>
                            <div class="bold" v-if="notaDebito.total && notaDebito.total">
                                {{ Util.Price(notaDebito.total) }}</div>
                            <div class="options icon-dots-vertical ml10" @click.stop="Options([
                                { text: 'Forzar estado OK', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin', confirm: '¿Se verificó que la nota de débito esté aprobada y recepcionada en el SII?', function: () => { ForceOkStatus(notaDebito) } },
                                { text: 'Obtener estado avanzado', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && notaDebito.status != 'OK', function: () => { GetAdvancedStatus(notaDebito.id, notaDebito.type) } },
                                { text: 'Obtener estado vía mail', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && notaDebito.xml_status_mail != null, function: () => { modalStatusXml = notaDebito.xml_status_mail } },
                                { text: 'Obtener registro', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && notaDebito.status != 'OK', function: () => { GetSqlDte(notaDebito.id, notaDebito.type) } },
                                { text: 'Descargar PDF', function: () => { $refs.invoiceSii.GetDtePDF(56, notaDebito.id, notaDebito.folio) }, icon: 'download' },
                                { text: 'Enviar Nota de Débito Electrónica', class: 'selected-color', function: () => { $refs.modalFacturaElectronica.OpenmodalSendDte(notaDebito, notaDebito.type) }, icon: 'mail' },
                            ])"></div>
                        </div>
                    </div>
                </div>
            </vertical-content>

            <vertical-content class="pa-body" slot="Guías de Despacho" ref="verticalContentDispatchGuides" @OnBottom="BottomDispatchGuides()" :list="dispatchGuides">
                <div class="secondary-text ta-center mt10" v-if="!dispatchGuides || !dispatchGuides.length">No hay registros de guías de despacho.</div>
                <div v-else>
                    <div class="section mb10 selectable" v-for="(dispatchGuide, index) in dispatchGuides" :key="index" @click="$refs.invoiceSii.modalFacturaDetail = dispatchGuide">
                        <div class="flex fill align-center">
                            <avatar class="mr10"
                            defaultImageIcon="130"
                            :color="AvatarColor(Util.FacturaStatus[dispatchGuide.status].color)">
                            </avatar>
                            <div class="flex column flex-fill">
                                <div class="bold"><span class="bold">{{Util.DTE[dispatchGuide.type]}} N°</span>{{ dispatchGuide.folio }}</div>
                                <div class="secondary-text" v-if="dispatchGuide.send_at">
                                    <span class="bold">Fecha de emisión: </span>{{ Util.Date(dispatchGuide.send_at, 'DD/MM/YYYY') }}
                                </div>
                                <div :class="`secondary-text ${Util.FacturaStatus[dispatchGuide.status].color}`"><span class="bold">Estado:
                                    </span>{{ Util.FacturaStatus[dispatchGuide.status].label }}</div>

                            </div>
                            <div class="bold" v-if="dispatchGuide.total && dispatchGuide.total">
                                {{ Util.Price(dispatchGuide.total) }}</div>
                            <div class="options icon-dots-vertical ml10" @click.stop="Options([
                                { text: 'Obtener estado vía mail', class: 'csupport', icon: 'lifebuoy', if: Auth.role == 'admin' && dispatchGuide.xml_status_mail != null, function: () => { modalStatusXml = dispatchGuide.xml_status_mail } },
                                { text: 'Imprimir', function: () => $refs.invoiceSii.PrintFactura(dispatchGuide), icon: 'print'},
                                { text: 'Descargar PDF', function: () => { $refs.invoiceSii.GetDtePDF(52, dispatchGuide.id, dispatchGuide.folio) }, icon: 'download' },
                                { text: 'Cancelar Guía de Despacho', if: dispatchGuide.status == 'OK', function: () => { CancelDispatchGuide(dispatchGuide.id) }, icon: 'forbidden' },
                            ])"></div>
                        </div>
                    </div>
                </div>
            </vertical-content>
            <vertical-content class="pa-body" slot="Receptores" ref="verticalContentReceivers" @OnBottom="BottomReceiver()"
                :list="receivers">
                <div>
                    <div class="secondary-text ta-center mt10" v-if="!receivers.length">No hay datos.</div>
                    <div v-else>
                        <div class="section mb10 selectable" v-for="(receiver, index) in receivers" :key="index"
                            @click="modalReceiverDetail = {receiver , facturas : [], tabs : ['General', 'Facturas']}">
                            <div class="flex fill align-center">
                                <avatar class="mr10"
                                :label="receiver.name"
                                color="AUTO">
                                </avatar>
                                <div class="flex column flex-fill">
                                    <div class="bold">{{ receiver.name }}</div>
                                    <div class="secondary-text" v-show="receiver.alias">{{ receiver.alias }}</div>
                                </div>
                                <div class="bold">
                                    {{ receiver.rut }}
                                </div>
                                <div class="options icon-dots-vertical ml10" @click.stop="Options([
                                    {
                                        text: 'Eliminar Receptor', class: 'error-color', function: () => {
                                            Confirm({
                                                title: `¿Eliminar este receptor?`,
                                                text: 'Confirmar',
                                                class: 'selected-color',
                                                function: () => { $refs.modalFacturaElectronica.deleteReceiver(receiver, false) }
                                            })
                                        },
                                        icon: 'trash'
                                    },
                                    { text: 'Editar Receptor', function: () => { $refs.modalFacturaElectronica.OpenModalReceiver(Util.Copy(receiver)) }, icon: 'edit' },
                                    { text: 'Emitir Factura', function: () => { $refs.modalFacturaElectronica.Open(33, Util.Copy(receiver)) }, icon: 'square-plus' },
                                ])"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </vertical-content>
        </tabs>

        <modal v-model="modalReceiverDetail" dir="right" :modalClass="['fill', 'sm right h100']" title="Detalles del receptor" hideActions>
            <input-date v-if="modalReceiverDetail && modalReceiverDetail.tab == 'Facturas'" slot="options" 
            icon="calendar" type="DATE" @OnAcceptDate="LoadFacturasReceiver($event, true)"></input-date>

            <input-select v-if="modalReceiverDetail && modalReceiverDetail.tab == 'Facturas'"
            class="ml5" inputClass="secondary" icon="sort"
            v-model="sortFacturasReceiver"
            slot="options"
            :items="[
                {text: 'Ordenar por número', value: 'folio,desc'},
                {text: 'Ordenar por emisión', value: 'issue_at,desc'},
            ]">
            </input-select>

            <tabs :tabs="modalReceiverDetail.tabs" v-if="modalReceiverDetail" :keyByTab="true" v-model="modalReceiverDetail.tab" @OnTabFacturas="LoadFacturasReceiver()">
                    <div slot="General" class="pa20" v-if="modalReceiverDetail.receiver">
                        <div class="mb15">
                            <div class="bold">Razón social</div>
                            <div>{{ modalReceiverDetail.receiver.name }} {{modalReceiverDetail.receiver.alias? `(${modalReceiverDetail.receiver.alias})` : ''}}</div>
                        </div>

                        <div class="mb15">
                            <div class="bold">RUT</div>
                            <div>{{ modalReceiverDetail.receiver.rut }}</div>
                        </div>

                        <div class="mb15">
                            <div class="bold">Giro del negocio</div>
                            <div>{{ modalReceiverDetail.receiver.line_business }}</div>
                        </div>

                        <div v-for="(data, index) in modalReceiverDetail.receiver.multi_address" :key="index" class="mb15 well">
                            <div class="mb10">
                                <div class="bold">Email</div>
                                <div>{{ data.email }}</div>
                            </div>

                            <div class="mb10">
                                <div class="bold">Dirección</div>
                                <div>{{ data.address }}</div>
                            </div>

                            <div class="mb10">
                                <div class="bold">Comuna</div>
                                <div>{{ data.commune }}</div>
                            </div>

                            <div class="mb10">
                                <div class="bold">Ciudad</div>
                                <div>{{ data.city }}</div>
                            </div>
                        </div>
                    </div>

                    <vertical-content slot="Facturas" ref="verticalReceiverFacturas"  class="pa20" v-if="modalReceiverDetail.facturas" @OnBottom="LoadFacturasReceiver()">
                        <div class="secondary-text ta-center mt10" v-if="!modalReceiverDetail.facturas.length">No hay facturas</div>
                        <div class="entry selectable"
                        v-for="(factura, index) in modalReceiverDetail.facturas"
                        :key="index"
                        @click="$refs.invoiceSii.modalFacturaDetail = factura">
                            <div class="flex fill align-center">
                                <div class="flex column">
                                    <div class="bold">Factura N°{{factura.folio}}</div>
                                    <div class="secondary-text"><span class="bold">Fecha de emisión: </span>{{Util.Date(factura.issue_at, 'DD/MM/YYYY')}}</div>
                                </div>
                                <div class="flex-fill"></div>
                                <div class="flex column mr10" style="text-align: right">
                                    <div class="bold">{{Util.Price(factura.total)}}</div>
                                </div>
                            </div>
                        </div>
                    </vertical-content>
                </tabs>
        </modal>

        <modal v-model="modalFacturaSearch" dir="center" modalClass="sm" title="Buscar Factura">
            <div class="section" v-if="modalFacturaSearch">
                <input-field
                v-model="modalFacturaSearch.number"
                label="Número de Factura"
                type="int+"
                prefix="# "
                @OnEnter="SearchFactura(0)">
                </input-field>
            </div>
            
            <button slot="actions" class="primary purple" @click="SearchFactura(0)">Buscar</button>
            
        </modal>

        <modal v-model="modalDteStatus" dir="center" modalClass="sm" title="Estado Dte">
            <div class="pa20" v-if="modalDteStatus">
                <p>Recibido: {{ modalDteStatus.RECIBIDO }}</p>
                <p>Estado: {{ modalDteStatus.ESTADO }}</p>
                <p>Glosa: {{ modalDteStatus.GLOSA }}</p>
                <p>Número de atención: {{ modalDteStatus.NUMATENCION }}</p>
            </div>

            <button slot="actions" class="primary purple" @click="modalDteStatus = null">Cerrar</button>
        </modal>

        <modal v-model="modalStatusXml" dir="center" modalClass="xl" title="Estado Avanzado">
            <div class="pa20" v-if="modalStatusXml">
                <pre v-text="modalStatusXml"></pre>
            </div>

            <button slot="actions" class="primary purple" @click="modalStatusXml = null">Cerrar</button>
        </modal>

        <modal-factura-electronica 
        ref="modalFacturaElectronica" 
        @generateDte="LoadDtes(true);
        LoadDispatchGuides(true);
        LoadNotasDeCredito(true);
        LoadNotasDeDebito(true);
        UpdateTabCount()"
        @reloadReceiver="GetReceivers(true);
        UpdateTabCount()">
        </modal-factura-electronica>

        <invoice-sii-detail
        ref="invoiceSii"
        :tab="tab"
        @SyncInventory="SyncInventory"
        >
        </invoice-sii-detail>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    data() {
        return {
            facturas: [],
            dtesReceived: [],
            notasCredito: [],
            notasDebito: [],
            dispatchGuides: [],
            modalReceiverDetail: null,
            search: null,
            searchFE: null,
            searchNC: null,
            searchND: null,
            searchGD: null,
            receivers: [],
            tab: null,
            tabs: null,
            searchReceiver: null,
            modalFacturaSearch: null,
            sortDtesReceived: null,
            sortFacturas: 'issue_at,desc',
            sortFacturasReceiver: 'issue_at,desc',
            modalDteStatus: null,
            tabCount: {},
            DTELabel: {
                33: {text: 'Factura'},
                56: {text: 'Nota de Débito'},
                61: {text: 'Nota de Crédito'},
                52: {text: 'Guía de despacho electrónica'},
            },
            debounceTimeout: null,
            modalStatusXml: null,
            rangeDtesReceived : null,
            searchDtesReceived: null,
            searchIssuerFE: null,
        }
    },
    mounted() {
        this.tabs = [];
        if (this.Local.modules.module_sii_factura && this.isAdmin) this.tabs.push('Documentos Recibidos');
        if ((this.Local.modules.module_sii_factura && this.isAdmin) || this.Auth.role == 'cashier') this.tabs.push('Facturas Electrónicas');
        if(this.Local.modules.module_sii_factura && this.isAdmin) {
            this.tabs.push('Notas de Crédito');
            this.tabs.push('Notas de Débito');
            this.tabs.push('Guías de Despacho');
            this.tabs.push('Receptores');
        }
        let start = moment('2025-01-01').startOf('day').unix();
        let end = moment().endOf('day').unix();

        this.$refs.rangeDate.start = start;
        this.$refs.rangeDate.end = end;
        this.$refs.rangeDate.currentOption = 'RANGE';
        this.$refs.rangeDate.SearchRange("Seleccionar rango de fecha");

        this.UpdateTabCount();
        // this.LoadDtesReceived();

    },
    methods: {
        LoadDtes(clear) {
            if(!this.sortFacturas) return;
            let parts = this.sortFacturas.split(',');

            if (clear) {
                this.facturas = [];
                this.$refs.verticalContentFacturas.Reset();
            }

            let date = this.searchFE;

            this.Loading();
            let params = new URLSearchParams({
                skip: this.facturas.length,
                orderBy: parts[0],
                orderDirection: parts[1],
            });

            if (this.searchIssuerFE) params.append('search', this.searchIssuerFE);

            axios.post(`/dte/${this.Local.id}/facturas?${params.toString()}`, {date})
            .then(({ data }) => {
                this.facturas = this.facturas.concat(data.facturas);
                if(data.count) this.$set(this.tabCount, 'Facturas Electrónicas', data.count);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });

            // this.LoadDtesReceived();
        },
        LoadNotasDeDebito(clear) {
            if (clear) {
                this.notasDebito = [];
                if(this.$refs.verticalContentNotasDebito) this.$refs.verticalContentNotasDebito.Reset();
            }

            this.Loading();
            let date = this.searchND;
            axios.post(`/dte/${this.Local.id}/notas_debito`, {date})
            .then(({data}) => {
                this.notasDebito = data.notas_debito;
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadNotasDeCredito(clear) {
            if (clear) {
                this.notasCredito = [];
                if(this.$refs.verticalContentNotasCredito) this.$refs.verticalContentNotasCredito.Reset();
            }

            this.Loading();
            let date = this.searchNC;
            axios.post(`/dte/${this.Local.id}/notas_credito`, {date})
            .then(({data}) => {
                this.notasCredito = data.notas_credito;
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadDtesReceived(clear) {

            if (clear) {
                this.dtesReceived = [];
                if(this.$refs.verticalContentReceived) this.$refs.verticalContentReceived.Reset();
            }
            this.Loading();

            let date = this.rangeDtesReceived;
            let sort = this.sortDtesReceived? this.sortDtesReceived : null;
            let last = !this.dtesReceived.length? null : this.dtesReceived[this.dtesReceived.length - 1].issue_at - 1;

            axios.post(`/dte/${this.Local.id}/received${this.searchDtesReceived ? `?search=${this.searchDtesReceived}` : ''}`, {date, last, sort})
            .then(({data}) => {
                // this.dtesReceived = data.dtes_received;
                this.dtesReceived = this.dtesReceived.concat(data.dtes_received);
                this.$set(this.tabCount, 'Documentos Recibidos', data.total);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadDispatchGuides(clear){
            if (clear) {
                this.dispatchGuides = [];
                if(this.$refs.verticalContentDispatchGuides) this.$refs.verticalContentDispatchGuides.Reset();
            }
            this.Loading();

            let date = this.searchGD;

            return axios.post(`/dte/${this.Local.id}/dispatch_guides`, {date})
            .then(({data}) => {
                this.dispatchGuides = data.dispatch_guides;
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        BottomFacturas() {
            if (!this.facturas.length) return;

            this.Loading();

            axios.post(`/dte/${this.Local.id}/facturas`, {
                last: this.facturas[this.facturas.length - 1].issue_at - 1
            })
            .then(({ data }) => {
                this.facturas = this.facturas.concat(data.facturas);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        BottomNotasCredito(){
            if (!this.notasCredito.length) return;

            this.Loading();

            axios.post(`/dte/${this.Local.id}/notas_credito`, {
                last: this.notasCredito[this.notasCredito.length - 1].send_at - 1
            })
            .then(({ data }) => {
                this.notasCredito = this.notasCredito.concat(data.notas_credito);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        BottomReceiver() {
            if (!this.receivers.length) return;

            this.Loading();

            axios.post(`/sii/receivers/${this.Local.id}`, {
                last: this.receivers[this.receivers.length - 1].created_at - 1,
                quantity: 10
            })
                .then(({ data }) => {
                    this.receivers = this.receivers.concat(data.receivers);
                    this.Response(data);
                }).catch(err => {
                    this.Response(err);
                });
        },
        BottomReceived() {
            if (!this.dtesReceived.length) return;

            this.Loading();
            let sort = this.sortDtesReceived? this.sortDtesReceived : null;
            let date = this.rangeDtesReceived;
            axios.post(`/dte/${this.Local.id}/received`, {
                date,
                last: this.dtesReceived[this.dtesReceived.length - 1].issue_at - 1,
                sort
            })
            .then(({ data }) => {
                this.dtesReceived = this.dtesReceived.concat(data.dtes_received);
                this.$set(this.tabCount, 'Documentos Recibidos', data.total);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        BottomDispatchGuides() {
            if (!this.dispatchGuides.length) return;

            this.Loading();

            axios.post(`/dte/${this.Local.id}/dispatch_guides`, {
                last: this.dispatchGuides[this.dispatchGuides.length - 1].send_at - 1
            })
            .then(({ data }) => {
                this.dispatchGuides = this.dispatchGuides.concat(data.dispatch_guides);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        CancelFactura(idFactura) {
            this.Loading();

            axios.post(`/sii/factura/${this.Local.id}/cancel`, {
                idFactura
            })
            .then(({ data }) => {
                this.LoadDtes();
                return this.Info(data.message);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        CancelDispatchGuide(idDte) {
            this.Loading();

            axios.post(`/sii/dispatch_guide/${this.Local.id}/cancel`, {idDte})
            .then(async ({ data }) => {
                await this.LoadDispatchGuides();
                this.Info(data.message);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        GetReceivers(clear, isSearch) {
            if (clear) {
                this.receivers = [];
                this.$refs.verticalContentReceivers.Reset();
            }

            if(!isSearch) this.Loading();
            axios.post(`/sii/receivers/${this.Local.id}`, { quantity: 10, search: this.searchReceiver })
                .then(({ data }) => {
                    this.receivers = data.receivers;
                    if(!isSearch) this.Response(data);
                })
                .catch(err => {
                    if(!isSearch) this.Response(err);
                })
        },
        LoadFacturasReceiver(range, clear){
            if(!this.sortFacturasReceiver) return;
            let parts = this.sortFacturasReceiver.split(',');
            let lengthFacturas = 0;

            let postData = {};

            if(this.modalReceiverDetail){
                postData.receiver = this.modalReceiverDetail.receiver;

                if (clear) {
                    this.modalReceiverDetail.facturas = [];
                    this.$refs.verticalReceiverFacturas.Reset();
                }

                let facturas = this.modalReceiverDetail.facturas;
                lengthFacturas = facturas.length;

                if(range){
                    this.$refs.verticalReceiverFacturas.Reset();
                    let date = range.endOf('day').unix();
                    this.modalReceiverDetail.facturas = [];
                    postData.date = date;
                }
            }

            this.Loading();
            axios.post(`/dte/${this.Local.id}/facturas?skip=${lengthFacturas}&orderBy=${parts[0]}&orderDirection=${parts[1]}`, postData).then(({data}) => {
                if(!this.modalReceiverDetail){
                    this.$set(this.modalReceiverDetail, 'facturas', data.facturas);
                    return this.Response(data);
                }

                if(range){
                    this.modalReceiverDetail.facturas = data.facturas;
                    return this.Response(data);
                }

                this.modalReceiverDetail.facturas = this.modalReceiverDetail.facturas.concat(data.facturas);
                return this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        SearchFactura(number){
            if(!this.modalFacturaSearch) return;

            if(number) this.modalFacturaSearch.number = parseInt(this.modalFacturaSearch.numer) + number;

            this.Loading();
            axios.post(`/dte/${this.Local.id}/facturas`, {idFactura: this.modalFacturaSearch.number}).then(({data}) => {
                if(data.status) this.$refs.invoiceSii.modalFacturaDetail = data.factura;
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        GetAdvancedStatus(idDte, type){
            this.Loading();
            axios.get(`/sii/dte/${idDte}/${type}/status`).then(({data}) => {
                this.Response(data);
                this.modalDteStatus = data;
            }).catch(err => {
                this.Response(err);
            });
        },
        AvatarColor(color){
            let background = '#34323e';
            const baseColor = Util.baseColors[color.slice(1)];
            if(baseColor) background = baseColor;
            return background;
        },
        GetSqlDte(idDte, type){
            this.Loading();
            axios.get(`/sii/dte/${idDte}/${type}/sql`, {responseType: 'blob'}).then((res) => {
                this.Util.DownloadFile(res, this.Util.Filename(`Dte_${type}`, 'sql', true));
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        ResendFactura(factura){
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(factura.xml, "application/xml");

            const correoRecep = xmlDoc.querySelector("CorreoRecep")? xmlDoc.querySelector("CorreoRecep").textContent : null

            const emisionDate = xmlDoc.querySelector("FchEmis").textContent;

            const emisor = {
                rut: xmlDoc.querySelector("RUTEmisor").textContent,
                razonSocial: xmlDoc.querySelector("RznSoc").textContent,
                giro: xmlDoc.querySelector("GiroEmis").textContent,
                direccion: xmlDoc.querySelector("DirOrigen").textContent,
                comuna: xmlDoc.querySelector("CmnaOrigen").textContent,
                acteco: xmlDoc.querySelector("Acteco").textContent,
            };

            const receptor = {
                rut: xmlDoc.querySelector("RUTRecep").textContent,
                razonSocial: xmlDoc.querySelector("RznSocRecep").textContent,
                giro: xmlDoc.querySelector("GiroRecep").textContent,
                correo: correoRecep,
                direccion: xmlDoc.querySelector("DirRecep").textContent,
                comuna: xmlDoc.querySelector("CmnaRecep").textContent,
            };

            const totals = {
                neto: xmlDoc.querySelector("MntNeto").textContent,
                iva: xmlDoc.querySelector("IVA").textContent,
                total: xmlDoc.querySelector("MntTotal").textContent,
                discount: xmlDoc.querySelector("ValorDR")? xmlDoc.querySelector("ValorDR").textContent : 0,
            };

            const parseMonto = (value) =>
                value ? parseInt(value.toString().replace(/\./g, ""), 10) : 0;
                
            factura.detailsItems = {
                items: factura.print_data.items.map((item) => ({
                    item: item.item || "SIN NOMBRE",
                    quantity: parseMonto(item.quantity) || 0,
                    price: parseMonto(item.price),
                    tax: parseMonto(item.tax),
                    taxPercentage: parseMonto(item.tax_percentage),
                    taxCode: item.taxCode || null,
                    discount: parseMonto(item.discount),
                    discountPercentage: parseMonto(item.discount_percentage),
                    mntNeto: parseMonto(item.neto) || (parseMonto(item.price) * item.quantity),
                    iva: parseMonto(item.iva),
                    affection: item.affection !== undefined ? item.affection : false,
                    total: parseMonto(item.total),
                    unitCost: parseMonto(item.unitCost),
                    unit: item.unit || null,
                })),
                total: {
                    mntNeto: totals.neto,
                    iva: totals.iva,
                    taxes: factura.print_data.items.reduce((acc, item) => acc + parseMonto(item.tax), 0),
                    discount: totals.discount ? Math.round(totals.discount) + Math.round(totals.discount * 0.19) : 0,
                    total: totals.total,
                },
            };

            if(factura.print_data.details_items) factura.detailsItems = factura.print_data.details_items;

            factura.detail = factura.detailsItems.items;
            if(factura.print_data.detail) factura.detail = factura.print_data.detail;

            factura.receiver = {
                "rut": receptor.rut,
                "name": receptor.razonSocial,
                "line_business": receptor.giro,
                "id_local": factura.id_local,
                "address": receptor.direccion.toUpperCase(),
                "city": receptor.comuna.toUpperCase(),
                "commune": receptor.comuna.toUpperCase(),
                "email": correoRecep? correoRecep.toUpperCase() : null,
            };

            factura.emisionDate = Date.parse(`${emisionDate}T00:00:00`) / 1000;

            factura.discount = parseInt(factura.print_data.descuento.replace(/\./g, ''), 10);
            factura.actecos = emisor.acteco;
            factura.receiver_address = {
                "address": receptor.direccion.toUpperCase(),
                "city": receptor.comuna.toUpperCase(),
                "commune": receptor.comuna.toUpperCase(),
                "email": correoRecep? correoRecep.toUpperCase() : null,
            };

            factura.payment_method = factura.print_data.payment_method;
            this.$refs.modalFacturaElectronica.generateFacturaElectronica(factura);
        },
        UpdateTabCount()
        {
            axios.get(`/sii/facturacion/${this.Local.id}/count`).then(res => {
                this.tabCount = {
                    'Facturas Electrónicas': res.data.facturas,
                    'Notas de Crédito': res.data.notas_credito,
                    'Notas de Débito': res.data.notas_debito,
                    'Guías de Despacho': res.data.dispatch_guides,
                    'Receptores': res.data.receivers,
                    'Documentos Recibidos': res.data.dtes_received
                }
            }).catch(err => {
                console.log(err);
            });
        },
        SyncInventory(idx,factura){
            this.dtesReceived[idx] = factura;
        },
        AppliedSummary(factura){
            if (!factura.print_data || !factura.print_data.items) return "";
            let items = factura.print_data.items;

            let msg = "Algunos ítems han sido ingresados";
            let color = "cyellow";
            const total = items.length;

            const applied = items.filter(it => it.applied === true).length;

            if (applied === 0) {
                msg = "Ningún ítem ha sido ingresado";
                color = "cred";
            }

            if (applied === total) {
                msg = "Todos los ítems han sido ingresado";
                color = "cgreen";
            }

            return {
                msg,
                color
            };
        },
        ForceOkStatus(factura) {
            this.Loading();
            axios.post(`/sii/dte/${this.Local.id}/status`, factura).then(({data}) => {
                Object.assign(factura, data.dte);
                return this.Info('Se actualizó el estado del Dte.');
            }).catch(err => {
                this.Response(err);
            });
        }
    },
    computed: {
        showProviders() {
            let ret = [];
            if(!this.searchDtesReceived) return this.dtesReceived;
            this.dtesReceived.forEach(element => {
                if(this.Util.InString(element.issuer_name, this.searchDtesReceived) || this.Util.InString(element.folio.toString(), this.searchDtesReceived)) ret.push(element);
            });
            return ret;
            
        }
    },
    watch: {
        sortFacturasReceiver: function(n, o) {
            this.LoadFacturasReceiver(null, true);
        },
        sortFacturas: function(n, o) {
            this.LoadDtes(true);
        },
        sortDtesReceived: function(n, o) {
            this.LoadDtesReceived(true);
        }
    }
}
</script>
